import { render, staticRenderFns } from "./SectionHowItWorks.vue?vue&type=template&id=53a08477&"
import script from "./SectionHowItWorks.vue?vue&type=script&lang=js&"
export * from "./SectionHowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./SectionHowItWorks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports